// extracted by mini-css-extract-plugin
export default {"cell":"TableColumnHeader_cell__DcSVC","focus":"TableColumnHeader_focus__XL8qf"};